/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesDraftTeamRoleSchema } from "./draftTeamRoleSchema.ts";
import { goodLuckCoreEntitiesDraftTeamSchema } from "./draftTeamSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesDraftTeamMemberSchema = z.object({
  id: z.string().nullish(),
  draftTeamId: z.string().nullish(),
  userId: z.string().nullish(),
  get role() {
    return goodLuckCoreEntitiesDraftTeamRoleSchema.optional();
  },
  get draftTeam() {
    return goodLuckCoreEntitiesDraftTeamSchema.optional();
  },
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
});
